// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"3dab0162","787":"b5c79a2c"}[chunkId] + ".chunk.js";
};